<ng-container *ngIf="!loading">
  <header class="dashboard-heading">
    <p class="portal-eyebrow">Licensing portal</p>
    <h1>Licenses &amp; applications</h1>
    <p>Manage your licenses and certifications. Choose a program to get started or continue an application.</p>
  </header>
  <section class="program-grid" aria-label="Licensing programs">
    <mat-card class="program-card">
      <mat-card-content>
        <mat-icon class="program-icon" aria-hidden="true">home_health</mat-icon>
        <h2>In Home Care</h2>
        <p>Apply for and manage your in-home care agency licenses.</p>
        <a mat-stroked-button color="primary" routerLink="/license/in-home-care">Manage in-home care <mat-icon iconPositionEnd>arrow_forward</mat-icon></a>
      </mat-card-content>
    </mat-card>
    <mat-card class="program-card" *ngIf="environment.displayHemotech">
      <mat-card-content>
        <mat-icon class="program-icon" aria-hidden="true">bloodtype</mat-icon>
        <h2>Hemodialysis Technician</h2>
        <p>Apply for and manage your hemodialysis technician certifications.</p>
        <a mat-stroked-button color="primary" routerLink="/license/hemo-tech">Manage certifications <mat-icon iconPositionEnd>arrow_forward</mat-icon></a>
      </mat-card-content>
    </mat-card>
    <mat-card class="program-card" *ngIf="environment.displayHospitals">
      <mat-card-content>
        <mat-icon class="program-icon" aria-hidden="true">local_hospital</mat-icon>
        <h2>Hospitals / SICF</h2>
        <p>Manage licenses for hospitals and Special Inpatient Care Facilities.</p>
        <a mat-stroked-button color="primary" routerLink="/license/hospital">Manage hospital licenses <mat-icon iconPositionEnd>arrow_forward</mat-icon></a>
      </mat-card-content>
    </mat-card>
  </section>
  <section class="dashboard-support" aria-labelledby="payments-heading">
    <div><h2 id="payments-heading">Application fees &amp; payments</h2><p>View your fees and manage payments in one place.</p></div>
    <a mat-button color="primary" routerLink="/payments">View payments <mat-icon iconPositionEnd>arrow_forward</mat-icon></a>
  </section>
</ng-container>
<div *ngIf="loading" class="portal-loading" role="status">
  <p>Loading your licenses…</p>
  <mat-progress-bar mode="indeterminate" aria-label="Loading your licenses"></mat-progress-bar>
</div>
